import * as PropTypes from 'prop-types';
import * as React from 'react';
import { CURRENCY_CODES, COUNTRY_CODES } from '../../../shared/constants';
import CountryCodeInput from './country_code_input';
import CurrencyInput from './currency_input';

const ACCOUNT_INPUT_LENGTH = 17;
const SORT_CODE_LENGTH = 2;

class UkBankFields extends React.Component {
  infoStoredSecurely() {
    if (this.props.dashboardView) {
      return false;
    }
    const lockIcon = '<i class="fa fa-lock"></i>';
    const text = I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.infoStoredSecurelyHtml', { lockIcon });

    return (
      <p
        className="fine-print mb-half"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  hasValidSelectedPayoutCurrency() {
    return !!this.props.currencies.find(currency => currency.code === this.props.selectedPayoutCurrency);
  }

  get currencyForInput() {
    if (this.hasValidSelectedPayoutCurrency()) {
      return this.props.selectedPayoutCurrency;
    }

    return CURRENCY_CODES.GBP;
  }

  get gbpSelected() {
    return this.currencyForInput === CURRENCY_CODES.GBP;
  }

  bankLocationDetailsInput() {
    return (
      <div className="mb-1">
        <div className="g-container">
          <CountryCodeInput
            countryCode={COUNTRY_CODES.UK}
            countryCodeOptions={this.props.countryCodeOptions}
            nameForField={fieldName => this.props.nameForField(fieldName)}
            onCountryChange={countryCode => this.props.onCountryChange(countryCode)}
          />

          <CurrencyInput
            selectedPayoutCurrency={this.currencyForInput}
            currencies={this.props.currencies}
            nameForField={fieldName => this.props.nameForField(fieldName)}
            onCurrencyChange={currencyCode => this.props.onCurrencyChange(currencyCode)}
          />
        </div>
      </div>
    );
  }

  get accountNumberFieldLabel() {
    if (this.gbpSelected) {
      return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.accountNumber');
    }
    return I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.iban');
  }

  accountNumberField() {
    return (
      <div className="g-col-6 g-col-mobile-12">
        <label className="string required">
          {this.accountNumberFieldLabel}
        </label>
        <input
          className="string required wide"
          maxLength={ACCOUNT_INPUT_LENGTH}
          type="text"
          name={this.props.nameForField('bank_account_number')}
        />
      </div>
    );
  }

  bicFields() {
    return (
      <div className="g-col-6 g-col-mobile-12">
        <label className="string required">
          {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.bicNumber')}
        </label>
        <input
          className="string required wide"
          maxLength={ACCOUNT_INPUT_LENGTH}
          type="text"
          name={this.props.nameForField('bic_number')}
        />
      </div>
    );
  }

  sortCodeFields() {
    return (
      <div className="g-col-6 g-col-mobile-12">
        <label className="string required">
          {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.sortCode')}
        </label>
        <div className="g-container">
          <div className="g-col-2">
            <input
              className="string required wide"
              maxLength={SORT_CODE_LENGTH}
              type="text"
              name={this.props.nameForField('sort_code')}
            />
          </div>
          <div className="g-col-1 pt-half align-center">
            -
          </div>
          <div className="g-col-2">
            <input
              className="string required wide"
              maxLength={SORT_CODE_LENGTH}
              type="text"
              name={this.props.nameForField('sort_code')}
            />
          </div>
          <div className="g-col-1 pt-half align-center">
            -
          </div>
          <div className="g-col-2">
            <input
              className="string required wide"
              maxLength={SORT_CODE_LENGTH}
              type="text"
              name={this.props.nameForField('sort_code')}
            />
          </div>
        </div>
      </div>
    );
  }

  bankCodeField() {
    if (this.gbpSelected) {
      return this.sortCodeFields();
    }
    return this.bicFields();
  }

  accountFields() {
    return (
      <div className="g-container">
        {this.bankCodeField()}
        {this.accountNumberField()}
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="g-container mb-1">
          <div className="g-col-6 g-col-mobile-12">
            <label>
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.nameOnAccount')}
            </label>
            <input
              className="string required wide mb-0"
              autoFocus="on"
              type="text"
              name={this.props.nameForField('name_on_account')}
            />
          </div>
        </div>
        {this.bankLocationDetailsInput()}
        {this.accountFields()}
      </div>
    );
  }
}

UkBankFields.propTypes = {
  countryCodeOptions: PropTypes.array.isRequired,
  nameForField: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  currencies: PropTypes.array.isRequired,
  dashboardView: PropTypes.bool.isRequired,
  selectedPayoutCurrency: PropTypes.string.isRequired,
};

export default UkBankFields;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/bank_account_fields/uk_bank_fields.jsx